import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../services/pocketbase';

// 1. Création du contexte
const AuthContext = createContext();

// 2. Création du fournisseur de contexte (Provider)
export function AuthProvider({ children }) {
  const [user, setUser] = useState(pb.authStore.model);

  useEffect(() => {
    const removeListener = pb.authStore.onChange((token, model) => {
      console.log('Auth state changed:', model);
      setUser(model);
    }, true);

    return () => removeListener();
  }, []);

  const login = async (email, password) => {
    await pb.collection('users').authWithPassword(email, password);
    // L'écouteur mettra à jour l'état
  };

  const register = async (email, password, passwordConfirm, name) => {
    // Générer un nom d'utilisateur unique
    const uniqueUsername = email.split('@')[0] + Date.now();
    
    const data = {
      username: uniqueUsername,
      email,
      password,
      passwordConfirm,
      name: name || '',
      role: 'user',
      emailVisibility: true,
      verified: false
    };

    // console.log('AuthContext - Données d\'inscription:', data);
    
    try {
      await pb.collection('users').create(data);
      // Après l'inscription, on connecte l'utilisateur
      await login(email, password);
    } catch (error) {
      console.error('AuthContext - Erreur d\'inscription:', error);
      throw error;
    }
  };

  const logout = () => {
    pb.authStore.clear();
    // L'écouteur mettra à jour l'état à null
  };

  const value = {
    user,
    isLoggedIn: !!user && pb.authStore.isValid,
    login,
    register,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

// 3. Création d'un hook personnalisé pour utiliser le contexte facilement
export function useAuth() {
  return useContext(AuthContext);
}
